import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/recruit/page.tsx");
